

import React from 'react';
import { Alert, Typography } from 'antd';

const { Paragraph, Text } = Typography;

const CustomerDataSection = () => {
  return (
    <div>
      <Paragraph>
        Customer retains ownership of all business data entered into, uploaded to,
        or generated through the TrackBiz platform, including customer records,
        inventory information, orders, appointments, reports, and other business
        information provided by Customer.
      </Paragraph>

      <Paragraph>
        <Text strong>Examples of Customer Data include:</Text>
      </Paragraph>

      <ul>
        <li>Customer names and contact information</li>
        <li>Inventory and product information</li>
        <li>Orders and transaction records</li>
        <li>Appointment schedules</li>
        <li>Employee information entered by Customer</li>
        <li>Business reports and analytics data</li>
        <li>Website content provided by Customer</li>
      </ul>

      <Alert
        message="Customer Retains Ownership"
        description="All Customer Data remains the property of Customer. This Agreement does not transfer ownership of Customer Data to Provider."
        type="success"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Provider may access Customer Data only as reasonably necessary to provide
        technical support, troubleshoot issues, maintain the platform, improve the
        software, process customer requests, or comply with legal obligations.
      </Paragraph>

      <Paragraph>
        Provider will use commercially reasonable administrative, technical, and
        organizational safeguards to help protect Customer Data from unauthorized
        access, disclosure, alteration, or destruction.
      </Paragraph>

      <Alert
        message="No Absolute Security Guarantee"
        description="While Provider implements reasonable security measures, no software platform, internet service, or cloud infrastructure can guarantee absolute security."
        type="warning"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph>
        Customer is responsible for maintaining appropriate backups of critical
        business records and for ensuring that data entered into TrackBiz is
        accurate, complete, and current.
      </Paragraph>

      <Paragraph>
        Provider will not sell Customer Data to third parties. However, Customer
        acknowledges that certain third-party service providers, including cloud
        hosting providers, payment processors, email delivery services, and domain
        providers, may process data as necessary to deliver the TrackBiz service.
      </Paragraph>
    </div>
  );
};

export default CustomerDataSection;